// extracted by mini-css-extract-plugin
export var quote = "quote-module--quote--6543d";
export var quoteFrom = "quote-module--quoteFrom--6eaab";